import CardAcceptor from './CardAcceptor.jsx';

export default CardAcceptor;